//============================================================================
// Name        : AddStorageUnit.jsx
// Purpose     : Implement adding a new storage unit
// Created     : 2019-07-08
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import React            from "react"
import PropTypes        from "prop-types"
import axios from "axios"

/** @jsx jsx */
import { css, jsx } from '@emotion/core'

const formGroup = css`
  margin-bottom: 10px;
  & > div {
    font-size: 16px;
  }
`;

class AddStorageUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      valid: false,
      name: '',
      measureUnit: ''
    }
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      show: props.show,
      valid: false,
      name: '',
      measureUnit: ''
    });
  }
  getClassName = () => {
    return this.state.show ? "modal show" : "modal fade";
  }

  onNameChange = (event) => {
    this.setState({ name: event.target.value });
    if (this.state.name.trim().length > 0) {
      this.setState({ valid: true });
    }
  }
  onMeasureUnitChange = (event) => {
    this.setState({ measureUnit: event.target.value });
  }

  onClose = () => this.hide()
  onSave = () => this.save()
  async save() {
    try {
      const data = {
        api_key: apiKey,
        name: this.state.name,
        measure_unit: this.state.measureUnit
      };
      await axios.post(storageUnitsApiUrl, data)
      this.hide();
    }
    catch (error) {
      console.log(error);
    }
  }
  hide = () => {
    this.setState({ show: false });
    this.props.callback();
  }

  render () {
    return (
      <div className={this.getClassName()} tabIndex="-1" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <button onClick={this.onClose} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h1 className="modal-title">New Storage Unit</h1>
            </div>

            <div className="modal-body">
              <div css={formGroup}>
                <div>Name</div>
                <input className="form-control" type="text" value={this.state.name} onChange={this.onNameChange} />
              </div>

              <div css={formGroup}>
                <div>Measure Unit</div>
                <input className="form-control" type="test" value={this.state.measureUnit} onChange={this.onMeasureUnitChange} />
              </div>
            </div>

            <div className="modal-footer" css={{ padding: '15px' }}>
              <button disabled={!this.state.valid} onClick={this.onSave} className="man-btn man-green-btn">Save</button>
              <button onClick={this.onClose} className="man-btn">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddStorageUnit.propTypes = {
  show: PropTypes.bool,
  callback: PropTypes.func
};

export default AddStorageUnit
